"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var kiwifruit_core_1 = require("kiwifruit-core");
var kiwifruit_parse_1 = require("kiwifruit-parse");
var required = kiwifruit_core_1.Constraint.required;
var BoxVarName;
(function (BoxVarName) {
    BoxVarName["left"] = "left";
    BoxVarName["right"] = "right";
    BoxVarName["width"] = "width";
    BoxVarName["hMid"] = "hMid";
    BoxVarName["top"] = "top";
    BoxVarName["bottom"] = "bottom";
    BoxVarName["height"] = "height";
    BoxVarName["vMid"] = "vMid";
})(BoxVarName = exports.BoxVarName || (exports.BoxVarName = {}));
function makeBox(name, addConstraint) {
    var left = name + "-left", right = name + "-right";
    var width = name + "-width", hMid = name + "-hMid";
    var top = name + "-top", bottom = name + "-bottom";
    var height = name + "-height", vMid = name + "-vMid";
    var constraints = [
        required(kiwifruit_parse_1.parseConstraintTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", " + ", " == ", ""], ["", " + ", " == ", ""])), left, width, right)),
        required(kiwifruit_parse_1.parseConstraintTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", " + ", " == ", ""], ["", " + ", " == ", ""])), top, height, bottom)),
        required(kiwifruit_parse_1.parseConstraintTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", " >= 0"], ["", " >= 0"])), width)),
        required(kiwifruit_parse_1.parseConstraintTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", " >= 0"], ["", " >= 0"])), height)),
        required(kiwifruit_parse_1.parseConstraintTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", " + ", " / 2 == ", ""], ["", " + ", " / 2 == ", ""])), left, width, hMid)),
        required(kiwifruit_parse_1.parseConstraintTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", " + ", " / 2 == ", ""], ["", " + ", " / 2 == ", ""])), top, height, vMid)),
    ];
    if (addConstraint) {
        addConstraint.apply(void 0, constraints);
    }
    return { name: name, left: left, right: right, width: width, hMid: hMid, top: top, bottom: bottom, height: height, vMid: vMid, constraints: constraints };
}
exports.makeBox = makeBox;
function isBoxRatherThanPoint(thing) {
    return thing.left !== undefined;
}
function boxEquals(b1, b2) {
    return [
        kiwifruit_parse_1.parseConstraintTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), b1.left, b2.left),
        kiwifruit_parse_1.parseConstraintTemplate(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), b1.right, b2.right),
        kiwifruit_parse_1.parseConstraintTemplate(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), b1.top, b2.top),
        kiwifruit_parse_1.parseConstraintTemplate(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), b1.bottom, b2.bottom),
    ];
}
exports.boxEquals = boxEquals;
function boxContains(larger, smaller, margin) {
    if (isBoxRatherThanPoint(smaller)) {
        return [
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", " <= ", " - ", ""], ["", " <= ", " - ", ""])), larger.left, smaller.left, margin || 0),
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", " >= ", " + ", ""], ["", " >= ", " + ", ""])), larger.right, smaller.right, margin || 0),
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", " <= ", " - ", ""], ["", " <= ", " - ", ""])), larger.top, smaller.top, margin || 0),
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", " >= ", " + ", ""], ["", " >= ", " + ", ""])), larger.bottom, smaller.bottom, margin || 0),
        ];
    }
    else {
        return [
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", " <= ", " - ", ""], ["", " <= ", " - ", ""])), larger.left, smaller.x, margin || 0),
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", " >= ", " + ", ""], ["", " >= ", " + ", ""])), larger.right, smaller.x, margin || 0),
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", " <= ", " - ", ""], ["", " <= ", " - ", ""])), larger.top, smaller.y, margin || 0),
            kiwifruit_parse_1.parseConstraintTemplate(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", " >= ", " + ", ""], ["", " >= ", " + ", ""])), larger.bottom, smaller.y, margin || 0),
        ];
    }
}
exports.boxContains = boxContains;
function boxShrink(box) {
    return [
        kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", " == 0"], ["", " == 0"])), box.width)),
        kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", " == 0"], ["", " == 0"])), box.height)),
    ];
}
exports.boxShrink = boxShrink;
function boxExpand(box) {
    return [
        kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), box.width, Infinity)),
        kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), box.height, Infinity)),
    ];
}
exports.boxExpand = boxExpand;
function treeFragmentIsConstraintsWithRoot(fragment) {
    return fragment.root !== undefined;
}
function treeFragmentIsBox(fragment) {
    return fragment.left !== undefined;
}
function treeFragmentIsArray(fragment) {
    return fragment.length !== undefined;
}
function flattenTreeChildren(fragments) {
    var constraints = [];
    var children = [];
    fragments.forEach(function (fragment) {
        if (treeFragmentIsConstraintsWithRoot(fragment)) {
            constraints.push.apply(constraints, fragment);
            children.push(fragment.root);
        }
        else if (treeFragmentIsBox(fragment)) {
            children.push(fragment);
        }
        else if (treeFragmentIsArray(fragment)) {
            var flattened = flattenTreeChildren(fragment);
            constraints.push.apply(constraints, flattened.constraints);
            children.push.apply(children, flattened.children);
        }
        else {
            children.push(fragment);
        }
    });
    return { children: children, constraints: constraints };
}
function attachRoot(constraints, root) {
    var constraintsWithRoot = constraints;
    constraintsWithRoot.root = root;
    return constraintsWithRoot;
}
function hasBoxRatherThanName(hasBoxOrName) {
    return hasBoxOrName.box !== undefined;
}
function getBoxFromOptions(hasBoxOrName, mutableConstraints) {
    if (hasBoxRatherThanName(hasBoxOrName)) {
        return hasBoxOrName.box;
    }
    else {
        if (hasBoxOrName.name === undefined) {
            throw new Error('a box or name is required for this function'); // for JS access
        }
        var box = makeBox(hasBoxOrName.name);
        mutableConstraints.push.apply(mutableConstraints, box.constraints);
        return box;
    }
}
function applyBoxVals(box, boxVals, mutableConstraints) {
    _.forEach(BoxVarName, function (varName) {
        var maybeVal = boxVals[varName];
        if (maybeVal !== undefined) {
            mutableConstraints.push(kiwifruit_core_1.Constraint.strong(kiwifruit_parse_1.parseConstraintTemplate(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), box[varName], maybeVal)));
        }
    });
}
function applyShrinkExpand(box, shrinkExpand, mutableConstraints) {
    var shrink = shrinkExpand.shrink, expand = shrinkExpand.expand;
    if (shrink == true || shrink == 'h') {
        mutableConstraints.push(kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", " == 0"], ["", " == 0"])), box.width)));
    }
    if (shrink == true || shrink == 'v') {
        mutableConstraints.push(kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", " == 0"], ["", " == 0"])), box.height)));
    }
    if (expand == true || expand == 'h') {
        mutableConstraints.push(kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), box.width, 1e10)));
    }
    if (expand == true || expand == 'v') {
        mutableConstraints.push(kiwifruit_core_1.Constraint.weak(kiwifruit_parse_1.parseConstraintTemplate(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), box.height, 1e10)));
    }
}
// TODO: version which doesn't take HasBoxOrName and only returns constraints (no root)
// TODO: `spacing` probably doesn't play nice with numbers as fragments
function rowOrColumn(_a) {
    var startVar = _a.startVar, endVar = _a.endVar, sizeVar = _a.sizeVar, alignmentVars = _a.alignmentVars;
    return function (options) {
        var fragments = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fragments[_i - 1] = arguments[_i];
        }
        var _a = flattenTreeChildren(fragments), children = _a.children, constraints = _a.constraints;
        var box = getBoxFromOptions(options, constraints);
        applyBoxVals(box, options, constraints);
        applyShrinkExpand(box, options, constraints);
        var align = options.align, spacing = options.spacing;
        var prevChild = undefined;
        children.forEach(function (child, i) {
            if (typeof child === 'number') {
                // Make a spacer box!
                // TODO: eliminate these! so silly!
                var spacerSize = child;
                child = makeBox(box.name + '-spacer-' + i);
                constraints.push.apply(constraints, child.constraints);
                constraints.push(kiwifruit_parse_1.parseConstraintTemplate(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), child[sizeVar], spacerSize));
            }
            constraints.push.apply(constraints, boxContains(box, child));
            if (align !== undefined) {
                var alignmentVar = alignmentVars[align];
                constraints.push(kiwifruit_parse_1.parseConstraintTemplate(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", " == ", ""], ["", " == ", ""])), child[alignmentVar], box[alignmentVar]));
            }
            if (prevChild) {
                constraints.push(kiwifruit_parse_1.parseConstraintTemplate(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", " >= ", " + ", ""], ["", " >= ", " + ", ""])), child[startVar], prevChild[endVar], spacing || 0));
            }
            prevChild = child;
        });
        return attachRoot(constraints, box);
    };
}
exports.tree = {
    box: function (options) {
        var fragments = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fragments[_i - 1] = arguments[_i];
        }
        var _a = flattenTreeChildren(fragments), children = _a.children, constraints = _a.constraints;
        var box = getBoxFromOptions(options, constraints);
        applyBoxVals(box, options, constraints);
        applyShrinkExpand(box, options, constraints);
        children.forEach(function (child) {
            constraints.push.apply(constraints, boxContains(box, child));
        });
        return attachRoot(constraints, box);
    },
    column: rowOrColumn({
        startVar: BoxVarName.top, endVar: BoxVarName.bottom, sizeVar: BoxVarName.height,
        alignmentVars: { left: BoxVarName.left, right: BoxVarName.right, middle: BoxVarName.hMid }
    }),
    row: rowOrColumn({
        startVar: BoxVarName.left, endVar: BoxVarName.right, sizeVar: BoxVarName.width,
        alignmentVars: { top: BoxVarName.top, bottom: BoxVarName.bottom, middle: BoxVarName.vMid }
    }),
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../kiwifruit/kiwifruit-box/build/index.js
// module id = 170
// module chunks = 0